module.exports = __webpack_public_path__ + "img/plac2.8831084c.jpg";